export enum DisputeReason {
    NO_AUTHORIZATION = "NO_AUTHORIZATION",
    CANCELED_CARDS_BULLETIN = "CANCELED_CARDS_BULLETIN",
    NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE = "NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE",
    NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM = "NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM",
    AUTHORIZATION_DENIED = "AUTHORIZATION_DENIED",
    DUPLICATE = "DUPLICATE",
    INCORRECT_TRANSACTION_CODE = "INCORRECT_TRANSACTION_CODE",
    CANCELLED_MERCHANDISE_OR_SERVICES = "CANCELLED_MERCHANDISE_OR_SERVICES",
    PAYMENT_BY_OTHER = "PAYMENT_BY_OTHER",
    EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD = "EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD",
    NOT_AUTHORIZED_CARD_ABSENT = "NOT_AUTHORIZED_CARD_ABSENT",
    CREDIT_NOT_PROCESSED = "CREDIT_NOT_PROCESSED",
    CANCELLED_RECURRING_TRANSACTION = "CANCELLED_RECURRING_TRANSACTION",
    COUNTERFEIT_MERCHANDISE = "COUNTERFEIT_MERCHANDISE",
    MISLEADING_STATEMENTS = "MISLEADING_STATEMENTS",
    INCORRECT_ACCOUNT_NUMBER = "INCORRECT_ACCOUNT_NUMBER",
    SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED = "SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED",
    INCORRECT_TRANSACTION_AMOUNT = "INCORRECT_TRANSACTION_AMOUNT",
    EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD = "EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD",
    LATE_PRESENTMENT = "LATE_PRESENTMENT",
    NOT_AUTHORIZED_CARD_PRESENT = "NOT_AUTHORIZED_CARD_PRESENT",
    INCORRECT_CURRENCY = "INCORRECT_CURRENCY"
}

export const VisaDisputeReasonCodes: Record<DisputeReason, number> = {
    [DisputeReason.NO_AUTHORIZATION]: 11.3,
    [DisputeReason.CANCELED_CARDS_BULLETIN]: 11.1,
    [DisputeReason.NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE]: 13.3,
    [DisputeReason.NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM]: 13.9,
    [DisputeReason.AUTHORIZATION_DENIED]: 11.2,
    [DisputeReason.DUPLICATE]: 12.6,
    [DisputeReason.INCORRECT_TRANSACTION_CODE]: 12.2,
    [DisputeReason.CANCELLED_MERCHANDISE_OR_SERVICES]: 13.7,
    [DisputeReason.PAYMENT_BY_OTHER]: 12.6,
    [DisputeReason.EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD]: 10.1,
    [DisputeReason.NOT_AUTHORIZED_CARD_ABSENT]: 10.4,
    [DisputeReason.CREDIT_NOT_PROCESSED]: 13.6,
    [DisputeReason.CANCELLED_RECURRING_TRANSACTION]: 13.2,
    [DisputeReason.COUNTERFEIT_MERCHANDISE]: 13.4,
    [DisputeReason.MISLEADING_STATEMENTS]: 13.5,
    [DisputeReason.INCORRECT_ACCOUNT_NUMBER]: 12.4,
    [DisputeReason.SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED]: 13.1,
    [DisputeReason.INCORRECT_TRANSACTION_AMOUNT]: 12.5,
    [DisputeReason.EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD]: 10.2,
    [DisputeReason.LATE_PRESENTMENT]: 12.1,
    [DisputeReason.NOT_AUTHORIZED_CARD_PRESENT]: 10.3,
    [DisputeReason.INCORRECT_CURRENCY]: 12.3
};


export const MastercardDisputeReasonCodes: Record<DisputeReason, number> = {
    [DisputeReason.NO_AUTHORIZATION]: null,
    [DisputeReason.CANCELED_CARDS_BULLETIN]: null,
    [DisputeReason.NOT_AS_DESCRIBED_OR_DEFECTIVE_MERCHANDISE]: null,
    [DisputeReason.NON_RECEIPT_OF_CASH_OR_LOAD_TRANSACTION_VALUE_AT_ATM]: null,
    [DisputeReason.AUTHORIZATION_DENIED]: 4808,
    [DisputeReason.DUPLICATE]: null,
    [DisputeReason.INCORRECT_TRANSACTION_CODE]: null,
    [DisputeReason.CANCELLED_MERCHANDISE_OR_SERVICES]: null,
    [DisputeReason.PAYMENT_BY_OTHER]: null,
    [DisputeReason.EMV_LIABILITY_SHIFT_COUNTERFEIT_FRAUD]: 4871,
    [DisputeReason.NOT_AUTHORIZED_CARD_ABSENT]: null,
    [DisputeReason.CREDIT_NOT_PROCESSED]: null,
    [DisputeReason.CANCELLED_RECURRING_TRANSACTION]: null,
    [DisputeReason.COUNTERFEIT_MERCHANDISE]: null,
    [DisputeReason.MISLEADING_STATEMENTS]: null,
    [DisputeReason.INCORRECT_ACCOUNT_NUMBER]: null,
    [DisputeReason.SERVICE_NOT_PROVIDED_MERCHANDISE_NOT_RECEIVED]: 4853,
    [DisputeReason.INCORRECT_TRANSACTION_AMOUNT]: null,
    [DisputeReason.EMV_LIABILITY_SHIFT_NON_COUNTERFEIT_FRAUD]: 4870,
    [DisputeReason.LATE_PRESENTMENT]: 4834,
    [DisputeReason.NOT_AUTHORIZED_CARD_PRESENT]: 4837,
    [DisputeReason.INCORRECT_CURRENCY]: null
};